import cx from 'classnames';
import PropTypes from 'prop-types';

import IconPlus from 'src/assets/icons/Plus';
import { CustomButtonBase } from 'src/components/CustomButtonBase';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

export const NewCard = ({ className, onClick, disabled }) => {
  const styles = useStyles();

  return (
    <CustomButtonBase
      className={cx(styles.root, className)}
      onClick={onClick}
      disabled={disabled}
    >
      <div className={styles.content}>
        <IconPlus className={styles.icon} />

        <CustomTypography
          className={styles.title}
          variant={TYPOGRAPHY_VARIANT.medium12}
        >
          New custom style
        </CustomTypography>
      </div>
    </CustomButtonBase>
  );
};

NewCard.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
NewCard.defaultProps = {
  className: null,
  disabled: false,
};
